import React, { useContext } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

import { ConfigContext } from 'context/config';
import { RokuSmartHomeLogo } from 'components/common/RokuSmartHomeLogo';
import { IconSmartHomeTick } from 'components/icons';

import styles from './mobileView.module.scss';

export const MobileView = () => {
  const { mobileDeeplink } = useContext(ConfigContext);

  return (
    <Stack className={styles.content}>
      <Box sx={{ mb: 6 }}>
        <RokuSmartHomeLogo />
      </Box>
      <Box sx={{ mb: 16 }}>
        <IconSmartHomeTick sx={{ fontSize: 72 }} />
      </Box>
      <Typography
        variant="h3"
        sx={{
          fontWeight: 500,
        }}
      >
        View your cameras in the Smart Home mobile app
      </Typography>
      <Box sx={{ mt: 6, mb: 6 }}>
        <Typography variant="body1" component="div">
          The screen you&apos;re trying to reach can&apos;t be
        </Typography>
        <Typography variant="body1" component="div">
          viewed on a mobile browser.
        </Typography>
      </Box>
      <Box className={styles.buttonContainer} sx={{ display: 'grid', mb: 4 }}>
        <Button
          variant="outlined"
          color="primary"
          href={mobileDeeplink}
          sx={{
            borderRadius: '5px',
            border: 'none',
            shadown: 'none',
            background: '#FFF',
            color: '#662D91',
            pt: '10px',
            pb: '10px',
          }}
        >
          Open mobile app
        </Button>
      </Box>
      <Box>
        <Typography variant="body2">You can also visit my.roku.com/smarthome</Typography>
        <Typography variant="body2">on a desktop or laptop computer</Typography>
      </Box>
    </Stack>
  );
};
